import React, { useState } from 'react';
import { SIMPLE_PEPTIDE_OPTIONS } from '../data';

export const BuyPeptides: React.FC = () => {
  const [selectedCategory, setSelectedCategory] = useState<string>('All');
  const [searchQuery, setSearchQuery] = useState<string>('');

  const categories = [
    'All',
    ...Array.from(
      new Set(SIMPLE_PEPTIDE_OPTIONS.flatMap((peptide) => peptide.categories))
    ),
  ];

  const filteredPeptides = SIMPLE_PEPTIDE_OPTIONS.filter(
    (peptide) =>
      (selectedCategory === 'All' || peptide.categories.includes(selectedCategory)) &&
      peptide.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div>
      {/* Hero Section */}
      <section className="relative bg-gray-50">
        <div className="absolute inset-0">
          <img
            src="/images/shop.jpg" // Ensure this path points to the correct image location
            alt="Peptide Vials and Syringes"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-blue-900 bg-opacity-80"></div> {/* Overlay for better text readability */}
        </div>
        <div className="relative max-w-6xl mx-auto px-6 py-20 text-center text-white">
          <h1 className="text-4xl font-bold mb-4">Explore Trusted Peptide Sources</h1>
        </div>
      </section>

      {/* Main Content */}
      <div className="max-w-5xl mx-auto p-8">
        <p className="text-gray-700 mb-6">
          Access high-quality peptides from verified suppliers. Use the coupon code{' '}
          <span className="font-semibold text-blue-600">peptidenow10</span> to save on your research peptides. Add the coupon to your cart directly using this link:
        </p>
        <a
          href="https://simplepeptide.com/cart/?coupon=peptidenow10"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition"
        >
          View Supplier Details
        </a>

        <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mt-6 rounded-lg">
          <p className="text-yellow-700 text-sm">
            Disclaimer: We are not affiliated with <strong>SimplePeptide.com</strong>, but we have used their services and are satisfied customers. The coupon code is provided to help you save on your research needs. All products are for research purposes only and not for human or veterinary use.
          </p>
        </div>

        <h2 className="text-2xl font-bold text-blue-600 mt-8 mb-4">
          Available Research Peptides
        </h2>

        {/* Filter and Search */}
        <div className="flex gap-4 mb-6">
          <div className="flex-1">
            <label className="block text-gray-700 mb-2">Filter by Category:</label>
            <select
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
              className="border border-gray-300 rounded-md p-2 w-full"
            >
              {categories.map((category) => (
                <option key={category} value={category}>
                  {category}
                </option>
              ))}
            </select>
          </div>
          <div className="flex-1">
            <label className="block text-gray-700 mb-2">Search by Name:</label>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search peptides..."
              className="border border-gray-300 rounded-md p-2 w-full"
            />
          </div>
        </div>


        {/* Peptide List */}
        <ul className="space-y-4">
          {filteredPeptides.map((peptide) => (
            <li key={peptide.id} className="bg-gray-50 p-4 rounded-lg shadow">
              <h3 className="text-lg font-semibold text-blue-600">{peptide.name}</h3>
              <p className="text-gray-600 mt-2">{peptide.description}</p>
              <div className="mt-4 flex space-x-4">
                <a
                  href={peptide.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="border border-gray-300 text-gray-600 px-4 py-2 rounded-lg hover:border-gray-400 hover:bg-gray-100 transition duration-200"
                >
                  Learn More
                </a>
                <a
                  href={`https://simplepeptide.com/cart/?add-to-cart=${peptide.productId}&quantity=1&coupon=peptidenow10`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-green-500 text-white px-4 py-2 rounded-lg shadow hover:bg-green-600 transition duration-200"
                >
                  Add to Cart
                </a>
              </div>
              <div className="mt-4 flex flex-wrap gap-2">
                {peptide.categories.map((category) => (
                  <button
                    key={category}
                    onClick={() => setSelectedCategory(category)}
                    className={`px-3 py-1 rounded-full text-sm ${
                      selectedCategory === category
                        ? 'bg-gray-200 text-gray-700'
                        : 'bg-gray-200 text-gray-700'
                    } hover:bg-blue-500 hover:text-white transition`}
                  >
                    {category}
                  </button>
                ))}
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
